'use strict';


let $ = require('jquery');
let form = require('../lib/form');

window.calculatorLog = [];

let COMPANIES_CACHE = {};
let PRODUCTS_CACHE = {};

function getCompanies(consumption, regionId)
{
    consumption = parseFloat(consumption).toFixed(1);
    if (regionId in COMPANIES_CACHE) {
        if (consumption in COMPANIES_CACHE[regionId]) {
            return COMPANIES_CACHE[regionId][consumption];
        }
    } else {
        COMPANIES_CACHE[regionId] = {};
    }

    let result = {};

    $.ajax({
        url: '/calculator/gas/companies/region/' + regionId + '/consumption/' + consumption,
        method: 'GET',
        async: false,
        success: function (data) {
            COMPANIES_CACHE[regionId][consumption] = data;
            result = data;
        }
    });

    return result;
}

function getProducts(companyId)
{
    if (companyId in PRODUCTS_CACHE) {
        return PRODUCTS_CACHE[companyId];
    } else {
        PRODUCTS_CACHE[companyId] = {};
    }

    let result = {};

    $.ajax({
        url: '/calculator/gas/products/companies/' + companyId,
        method: 'GET',
        async: false,
        success: function (data) {
            PRODUCTS_CACHE[companyId] = data;
            result = data;
        }
    });

    return result;
}

function roundNumber(number: number, decimals: number): number {
    return Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

function m3ToMwh(m3: number): number {
    return roundNumber(m3 / 1000 * 10.55, 3);
}

function mwhToM3(mwh: number): number {
    return roundNumber(mwh * 1000 / 10.55, 3);
}

function setNumberFieldValue($field: $, value: number) {
    if ($field.attr('type') != 'number') {
        value = value.toString().replace('.', ',');
    }

    $field.val(value).trigger('change');
}

function setupConsumptionRecalculation($container: $) {
    let $mwh = $(':input[name$="[consumption]"]', $container);
    let $m3 = $(':input[name$="[consumptionM3]"]', $container);
    let recalculating = false;

    $mwh.on('input', function () {
        if (recalculating) {
            return;
        }

        let mwh = form.getNumberFieldValue($mwh, true);
        if (mwh === null) {
            $m3.val('');
        } else {
            setNumberFieldValue($m3, mwhToM3(mwh));
        }
    });

    $m3.on('input', function () {
        if (recalculating) {
            return;
        }

        let m3 = form.getNumberFieldValue($m3, true);
        if (m3 === null) {
            $mwh.val('');
        } else {
            setNumberFieldValue($mwh, m3ToMwh(m3));
        }
    });

    $mwh.trigger('input');
}

function getMwhConsumption($consumptionType: $, $houseType: $, $consumptionMwh: $, $usagePurpose: $): ?number {
    const hasAccurateConsumption = $consumptionType.filter(':checked').val() === '1';
    const houseType = $houseType.val() || null;

    if (hasAccurateConsumption) {
        return form.getNumberFieldValue($consumptionMwh);

    } else if (houseType) {
        let usagePurposes = $usagePurpose.filter(':checked').map(function () {
            return $(this).attr('value');
        }).toArray();
        return window.gas_usage_mwh
            .filter((item) => item.house_id === houseType && usagePurposes.includes(item.usage_id))
            .reduce((prev, current) => prev + parseFloat(current.mwh), 0)
            ;

    } else {
        return null;
    }
}

function updateSuppliersList($currentCompany: $, $countryRegion: $, $consumptionType: $, $consumptionMwh: $, $houseType: $, $usagePurpose: $) {
    const countryRegion = $countryRegion.val();
    const consumption = getMwhConsumption($consumptionType, $houseType, $consumptionMwh, $usagePurpose);
    if (!consumption) {
        const hasAccurateConsumption = $consumptionType.filter(':checked').val() === '1';
        const hasDownPaymentConsumption = $consumptionType.filter(':checked').val() === '3';

        if (hasAccurateConsumption) {
            form.setSelectItems($currentCompany, ['<option value="">Zadejte výši své spotřeby plynu</option>']);
        } else if (!hasDownPaymentConsumption) {
            form.setSelectItems($currentCompany, ['<option value="">Nejprve vyberte, k čemu plyn využíváte</option>']);
        }

        return;
    }

    if (!countryRegion) {
        form.setSelectItems($currentCompany, ['<option value="">Nejprve vyberte kraj</option>']);
        return;
    }

    updateSuppliersList_int($currentCompany, countryRegion, consumption);
}

function updateSuppliersList_int($currentCompany: $, countryRegion: number, consumption: number) {
    let dominantCompanies = {};
    let mostUsedCompanies = {};
    let visibleCompanies = {};
    let dominantCompanyId = '';

    // currentValue normalne drzi filterSelectItems, tady je ale problem, ze az po filtrovani se nastavuje hodnota
    // pro 'Neznam dodavatele' a nastaveni se musi delat az potom
    const $currentOption = $currentCompany.find('option:selected');
    let currentSelector = $currentOption.is('[data-unknown]') ? '[data-unknown]' : `[value="${$currentOption.attr('value')}"]`;

    getCompanies(consumption, countryRegion).forEach(company => {
        visibleCompanies[company.id] = true;

        if (company.isMostUsed) {
            mostUsedCompanies[company.id] = true;
        }

        if (company.dominant) {
            dominantCompanies[company.id] = true;
            dominantCompanyId = company.id;
        }
    });

    const GROUP_DOMINANT = 'Dominantní dodavatel';
    const GROUP_MOST_USED = 'Nejčastější dodavatelé';
    const GROUP_ALL = 'Všichni dodavatelé';

    form.groupSelectItems($currentCompany, [GROUP_DOMINANT, GROUP_MOST_USED, GROUP_ALL], (option) => {
        const value = $(option).attr('value');

        if (value === '') {
            return [''];
        }

        const groups = [];

        if (visibleCompanies[value]) {
            groups.push(GROUP_ALL);

            if (dominantCompanies[value]) {
                groups.push(GROUP_DOMINANT);
            } else if (mostUsedCompanies[value]) {
                groups.push(GROUP_MOST_USED);
            }
        }

        return groups;
    });

    $currentCompany.children(`optgroup`).last().prepend(`<option value="${dominantCompanyId}" data-unknown="1">✕ Neznám dodavatele</option>`);
    $currentCompany.find(currentSelector).first().attr('selected', true);
}

function updateProductsList($currentProduct: $, $currentCompany: $, $countryRegion: $, $consumptionType: $, $consumptionMwh: $, $houseType: $, $usagePurpose: $) {
    const currentCompanyId = parseInt($currentCompany.val());
    const countryRegionId = $countryRegion.val();
    const consumption = getMwhConsumption($consumptionType, $houseType, $consumptionMwh, $usagePurpose);

    if (!countryRegionId || !consumption || !currentCompanyId) {
        form.setSelectItems($currentProduct, ['<option value="">Nejprve vyberte současného dodavatele</option>']);
        return;
    }


    updateProductsList_int($currentProduct, countryRegionId, consumption, currentCompanyId);
}

function updateProductsList_int($currentProduct: $, countryRegionId: number, consumption: number, currentCompanyId: number) {
    let visibleProducts = {};
    consumption = parseFloat(consumption).toFixed(1);
    let defaultProductId = COMPANIES_CACHE[countryRegionId][consumption].find(company => company.id === currentCompanyId).defaultProductId;
    getProducts(currentCompanyId).forEach(product => {
        visibleProducts[product.id] = true;
    });

    // currentValue normalne drzi filterSelectItems, tady je ale problem, ze az po filtrovani se nastavuje hodnota
    // pro 'Vyberte', 'Jiny produkt' a 'Nevim' a nastaveni se musi delat az potom
    const currentValue = $currentProduct.val();

    form.filterSelectItems($currentProduct, (option) => {
        let value = $(option).attr('value');
        return value === '' || visibleProducts[value];
    }, false);

    $currentProduct.find(`[value=""]`).attr('value', defaultProductId);
    $currentProduct.append(`<option value="${defaultProductId}">Jiný produkt</option>`); // Přidat na konec
    $currentProduct.append(`<option value="${defaultProductId}">Nevím</option>`); // *** Přidat *úplně* na konec

    let $currentProductItem = $currentProduct.find(`[value="${currentValue}"]`);
    if ($currentProductItem.length === 0) {
        // Pokud v selectu není existující produkt k ${currentValue}, přepnul jsem dodavatele nebo jsem přišel na stránku poprvé
        $currentProductItem = $currentProduct.find(`[value="${defaultProductId}"]`).last(); // "Nevím" (viz ***)
    } else {
        // V selectu existují čtyři optiony se stejnou value (Vyberte produkt, <jméno produktu>, "Jiný produkt", "Nevím")
        // Pokud je vybrán defaultní produkt, musím zobrazit option s jeho konkrétním jménem, což je *druhý* ze čtyř (tj. index 1)
        // Pokud není vybrán defaultní produkt, zobrazuji první option s patřičnou value (tj. index 0)
        let index = currentValue === defaultProductId ? 1 : 0;
        $currentProductItem = $currentProductItem.eq(index);
    }
    $currentProductItem.attr('selected', true);
}

function onExternalDataReady($form: $) {
    const $currentCompany = form.findField($form, 'company_id');
    const $currentProduct = form.findField($form, 'actual_product_id');
    const $countryRegion = form.findField($form, 'country_region_id');
    const $consumptionType = form.findField($form, 'accurate_consumption_type_id');
    const $consumptionMwh = form.findField($form, 'consumption');
    const $houseType = form.findField($form, 'house_type_id');
    const $usagePurpose = form.findField($form, 'usagePurpose', true);

    // schovat validaci
    $usagePurpose.closest('.form-widget').find('.form-message').hide();
    // nastaveni change listeneru
    $countryRegion.on('change', function () {
        updateSuppliersList($currentCompany, $countryRegion, $consumptionType, $consumptionMwh, $houseType, $usagePurpose);
    });

    $consumptionType.on('change', function () {
        let formDetailsBlock = $('#calc-details');

        //set class based on  value
        if($(this).val() == '1') {
            formDetailsBlock.addClass('option-1');
            formDetailsBlock.removeClass('option-2');
        } else {
            formDetailsBlock.addClass('option-2');
            formDetailsBlock.removeClass('option-1');
        }
        updateSuppliersList($currentCompany, $countryRegion, $consumptionType, $consumptionMwh, $houseType, $usagePurpose);
    });

    $consumptionMwh.on('change', function () {
        updateSuppliersList($currentCompany, $countryRegion, $consumptionType, $consumptionMwh, $houseType, $usagePurpose);
    });

    $houseType.on('change', function () {
        updateSuppliersList($currentCompany, $countryRegion, $consumptionType, $consumptionMwh, $houseType, $usagePurpose);
    });

    $usagePurpose.on('change', function () {
        updateSuppliersList($currentCompany, $countryRegion, $consumptionType, $consumptionMwh, $houseType, $usagePurpose);
    });

    $currentCompany.on('change', function () {
        updateProductsList($currentProduct, $currentCompany, $countryRegion, $consumptionType, $consumptionMwh, $houseType, $usagePurpose);
    });

    // prednastaveni currentCompany podle aktualne nastaveneho produktu
    // drive vybrana company se ze serveru neposila
    const currentProduct = $currentProduct.val();
    if (currentProduct !== '') {
        JSON.parse(window.gas_suppliers).some(function (product) {
            if (product.id === currentProduct) {
                $currentCompany.find(`[value="${product.company_id}"]`).first().attr('selected', true);
                return true;
            }

            return false;
        });
    }

    updateSuppliersList($currentCompany, $countryRegion, $consumptionType, $consumptionMwh, $houseType, $usagePurpose);
    updateProductsList($currentProduct, $currentCompany, $countryRegion, $consumptionType, $consumptionMwh, $houseType, $usagePurpose);
}

function loadExternalData(readyCb: () => void) {
    if (typeof window.gas_suppliers !== 'undefined') {
        readyCb();

    } else {
        window.gas_usage_mwh = [];
        window.gas_suppliers = [];

        $.ajax({
            url: '/calculator/gas/usage',
            dataType: 'script',
            cache: true
        }).done(function (data) {
            window.gas_usage_mwh = JSON.parse(data)
            readyCb();
        }).fail(function () {
            alert('Nepodařilo se načíst některá potřebná data. Zkuste se prosím na stránku vrátit později.');
        });
    }
}

$(function () {
    let $form = $('form[name^="web_gas_calculation_entryForm"]');
    if ($form.length === 0) {
        return;
    }

    setupConsumptionRecalculation($form);

    const $currentCompany = form.findField($form, 'company_id');
    const $currentProduct = form.findField($form, 'actual_product_id');

    function onCompanyChange() {
        const $selectedOption = $currentCompany.find('option:selected');
        const companyId = $selectedOption.attr('value');

        form.findRow($currentProduct).toggle(companyId !== '' && $selectedOption.data('unknown') !== 1);
    }

    $currentCompany.on('change', onCompanyChange);
    onCompanyChange();

    // nacteni externich dat + inicializace poli
    loadExternalData(() => {
        onExternalDataReady($form);
        onCompanyChange();
    });

    // USE-7796 - disable js validace pro produkt, kontrola jen na serveru. Za urcitych okolnosti se stava, ze je oznacen jako povinny u JS validaci
    $currentProduct.jsFormValidator({
        disabled: true
    });

    // inicialice form validace
    $form.jsFormValidator({
        groups: function () {
            let groups = ['Default'];
            let $accurateConsumption = $(':input[name$="[accurate_consumption_type_id]"]', $form).filter(':checked');

            if ($accurateConsumption.length > 0) {
                if ($accurateConsumption.val() === '1') {
                    groups.push('accurate_consumption');
                } else if ($accurateConsumption.val() === '3') {
                    groups.push('downpayment_consumption');
                } else {
                    groups.push('inaccurate_consumption');
                }
            }

            return groups;
        }
    });

});



// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/form.gasCalculator.js